import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ConfigurationGroupType } from 'shared-types/SpaPackage';

import { SpaPackageFormValues } from '../../SpaPackageForm.schema';
import { clearGenderIncompatibleSelections } from '../SpaDayBooking.helpers';

type UseClearGenderIncompatibleSelectionsParams = {
  form: UseFormReturn<SpaPackageFormValues>;
  watchedGuests: SpaPackageFormValues['guests'] | undefined;
  configGroupsNoExtras: ConfigurationGroupType[];
};

export function useClearGenderIncompatibleSelections({
  form,
  watchedGuests,
  configGroupsNoExtras,
}: UseClearGenderIncompatibleSelectionsParams) {
  useEffect(() => {
    if (!watchedGuests?.length || configGroupsNoExtras.length === 0) return;

    let changed = false;
    const nextGuests = watchedGuests.map((guest) => {
      const { selections, clearedGroupIds } = clearGenderIncompatibleSelections(
        configGroupsNoExtras,
        guest.configurationGroups,
        guest.gender
      );
      if (clearedGroupIds.length === 0) return guest;
      changed = true;
      return { ...guest, configurationGroups: selections };
    });

    if (changed) form.setValue('guests', nextGuests, { shouldDirty: true });
  }, [form, watchedGuests, configGroupsNoExtras]);
}
